class InfiniteScrollPagination extends HTMLElement {
  constructor() {
    super();
    // --- START ORIGINAL SELECTORS ---
    const watcher = this.querySelector('.pagination-wrapper.more');
    const moreAnchor = this.querySelector('.pagination-wrapper.more > a');
    if (moreAnchor) moreAnchor.style.pointerEvents = 'none';

    let observerOptions = {
      root: null,
      rootMargin: '0px 0px 200% 0px',
      threshold: 0,
    };

    let phase = 'inStock';
    // --- END ORIGINAL SELECTORS ---

    // --- NEW: RESTORATION WRAPPER ---
    const init = async () => {
      const navigationEntries = performance.getEntriesByType('navigation');
      const isBackForward = navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward';
      const lastPage = parseInt(sessionStorage.getItem('collectionPageLoaded'));

      setupScrollSaving();

      if (isBackForward && lastPage && lastPage >= 2) {
        // Display overlay and jump to top to prevent observer firing early
        const overlay = document.querySelector('.loading-overlay-container');
        if (overlay) overlay.style.display = 'flex';
        window.scrollTo(0, 0);

        console.log(`Restoring up to page ${lastPage}...`);
        for (let p = 2; p <= lastPage; p++) {
          await loadMoreContent(p); // Call original function with forced page
        }

        const savedScroll = sessionStorage.getItem('scrollPosition');
        if (savedScroll) {
          setTimeout(() => {
            window.scrollTo({ top: parseInt(savedScroll), behavior: 'instant' });
            if (overlay) overlay.style.display = 'none';
          }, 150);
        }
      } else if (!isBackForward) {
        sessionStorage.removeItem('scrollPosition');
        sessionStorage.removeItem('collectionPageLoaded');
      }

      // Start observing AFTER restoration
      if (watcher) {
        observer.observe(watcher);
      }
      
      // Final call to ensure content fills screen
      await loadMoreContent();
    };

    function setupScrollSaving() {
      document.addEventListener('click', function (event) {
        const link = event.target.closest('a');
        if (!link) return;
        const card = link.closest('li.grid__item');
        if (card) {
          sessionStorage.setItem('scrollPosition', window.scrollY);
        }
      });
    }

    let observer = new IntersectionObserver(async (entries, observer) => {
      for (let entry of entries) {
        if (entry.isIntersecting) {
          await loadMoreContent();
        }
      }
    }, observerOptions);

    function hasExplicitAvailabilityFilter() {
      const params = new URLSearchParams(window.location.search);
      return Array.from(params.keys()).some((key) => key.includes('availability'));
    }

    // --- YOUR ORIGINAL LOADMORECONTENT (Updated to accept forcedPage) ---
    async function loadMoreContent(forcedPage = null) {
      try {
        if (!moreAnchor) return;

        const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
        const scrollPosition = scrollTop + clientHeight;
        const scrollOffset = 6000;

        // Condition: Run if manually forced OR if user scrolled into view
        if (forcedPage || (scrollPosition >= scrollHeight - scrollOffset && moreAnchor.innerHTML != watcher.dataset.loading)) {
          
          if (!forcedPage) moreAnchor.innerHTML = watcher.dataset.loading;

          const anchorURL = new URL(moreAnchor.href);
          let page = forcedPage || anchorURL.searchParams.get('page') || 1;
          let currentURL = new URL(moreAnchor.baseURI);

          const productGrid = document.querySelector('ul#product-grid');
          const explicitAvailability = hasExplicitAvailabilityFilter();

          if (!explicitAvailability) {
            const needsFirstPageFetch = !productGrid?.dataset.firstPageFetched;
            if (needsFirstPageFetch && !forcedPage) {
              page = 1;
              productGrid.dataset.firstPageFetched = true;
            }

            const availabilityInput = document.querySelector(
              'li[data-radio-group="availability"] input'
            );
            const availabilityParamName = availabilityInput
              ? availabilityInput.name
              : 'filter.v.availability';

            const availabilityValue = phase === 'inStock' ? '1' : '0';
            currentURL.searchParams.set(availabilityParamName, availabilityValue);
          }

          currentURL.searchParams.set('page', page);

          const response = await fetch(currentURL.toString());
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.body.querySelector('ul#product-grid')?.innerHTML;

          sessionStorage.setItem('collectionPageLoaded', page);

          if (source && source.trim()) {
            productGrid.insertAdjacentHTML('beforeend', source);
            const nextPage = parseInt(page) + 1;

            if (nextPage <= parseInt(moreAnchor.id)) {
              anchorURL.searchParams.set('page', nextPage);
              moreAnchor.href = anchorURL.href;
              moreAnchor.innerHTML = watcher.dataset.noticelabel;
            } else {
              if (phase === 'inStock' && !hasExplicitAvailabilityFilter()) {
                phase = 'outOfStock';
                const outURL = new URL(moreAnchor.baseURI);
                const availabilityInput = document.querySelector(
                  'li[data-radio-group="availability"] input'
                );
                const availabilityParamName = availabilityInput
                  ? availabilityInput.name
                  : 'filter.v.availability';

                outURL.searchParams.set(availabilityParamName, '0');
                outURL.searchParams.set('page', '1');
                moreAnchor.href = outURL.toString();
                moreAnchor.innerHTML = watcher.dataset.noticelabel;
              } else {
                moreAnchor.remove();
              }
            }
          } else {
            if (phase === 'inStock' && !hasExplicitAvailabilityFilter()) {
              phase = 'outOfStock';
              const outURL = new URL(moreAnchor.baseURI);
              const availabilityInput = document.querySelector(
                'li[data-radio-group="availability"] input'
              );
              const availabilityParamName = availabilityInput
                ? availabilityInput.name
                : 'filter.v.availability';

              outURL.searchParams.set(availabilityParamName, '0');
              outURL.searchParams.set('page', '1');
              moreAnchor.href = outURL.toString();
              moreAnchor.innerHTML = watcher.dataset.noticelabel;
            } else {
              moreAnchor.remove();
            }
          }
        }
      } catch (error) {
        console.error(error);
        moreAnchor.style.pointerEvents = 'auto';
      }

      window.dispatchEvent(new Event('more-content-loaded'));
    }

    // Start the combined init logic
    init();
  }
}

customElements.define('infinite-scroll-pagination', InfiniteScrollPagination);